// ===== ENUMS =====
export const FIELDS = [
  'בנייה', 'תשתיות', 'אנרגיה', 'תחבורה', 'ייעוץ',
  'טכנולוגיה', 'שירותים', 'סטטוטורי', 'תכנון', 'בריאות', 'אחר'
];

export const STATUSES = ['בבחינה', 'בהכנה', 'הוגש'];

export const WIN_METHODS = ['מחיר', '%_איכות', '%_מחיר', 'איכות בלבד', 'אחר'];

export const WIN_STATUSES = ['', 'ממתין להחלטה', 'זכייה', 'אי-זכייה'];

export const PRIORITIES = ['גבוה', 'בינוני', 'נמוך'];

export const CATEGORIES = {
  active: { label: 'מכרזים פעילים', key: 'active' },
  submitted: { label: 'הוגשו', key: 'submitted' },
  skipped: { label: 'לא ניגשנו', key: 'skipped' },
  clarification: { label: 'שאלות הבהרה לטיפול', key: 'clarification' },
  upcoming: { label: 'הגשה לטיפול', key: 'upcoming' },
  won: { label: 'זכיות', key: 'won' },
  lost: { label: 'אי-זכיות', key: 'lost' },
};

export const ROLES = {
  ADMIN: 'admin',
  COORDINATOR: 'coordinator',
  USER: 'user',
};

export const ROLE_LABELS = {
  admin: 'מנהל מערכת',
  coordinator: 'רכז מכרזים',
  user: 'משתמש רגיל',
};

export const ROW_COLORS = [
  { label: 'ללא צבע', value: '' },
  { label: 'אדום', value: '#FFEBEE' },
  { label: 'כתום', value: '#FFF3E0' },
  { label: 'צהוב', value: '#FFF8E1' },
  { label: 'ירוק', value: '#E8F5E9' },
  { label: 'כחול', value: '#E3F2FD' },
  { label: 'סגול', value: '#F3E5F5' },
];

// ===== STAT CARDS =====
export const STAT_CARDS = [
  { key: 'total', label: 'סה"כ מכרזים', icon: 'FolderOpen', color: '#1565C0', bgColor: '#E3F2FD' },
  { key: 'submitted', label: 'הוגשו', icon: 'Send', color: '#2E7D32', bgColor: '#E8F5E9' },
  { key: 'skipped', label: 'לא ניגשנו', icon: 'Block', color: '#757575', bgColor: '#F5F5F5' },
  { key: 'clarification', label: 'שאלות הבהרה', icon: 'HelpOutline', color: '#FF6F00', bgColor: '#FFF3E0' },
  { key: 'upcoming', label: 'הגשה לטיפול', icon: 'Schedule', color: '#F57F17', bgColor: '#FFF8E1' },
  { key: 'won', label: 'זכיות', icon: 'EmojiEvents', color: '#2E7D32', bgColor: '#E8F5E9' },
  { key: 'lost', label: 'אי-זכיות', icon: 'Cancel', color: '#C62828', bgColor: '#FFEBEE' },
];

// ===== TABLE COLUMNS =====
export const TABLE_COLUMNS = [
  { field: 'id', headerName: 'מס"ד', width: 70, sortable: true },
  { field: 'tender_number', headerName: 'מספר מכרז', width: 120 },
  { field: 'client', headerName: 'מזמין', width: 150 },
  { field: 'subject', headerName: 'נושא המכרז', width: 250, flex: 1 },
  { field: 'field', headerName: 'תחום', width: 110 },
  { field: 'status', headerName: 'סטטוס', width: 100 },
  { field: 'win_method', headerName: 'אופן זכייה', width: 120 },
  { field: 'manager', headerName: 'מנהל', width: 120 },
  { field: 'handler', headerName: 'גורם מטפל', width: 120 },
  { field: 'bidders_meeting', headerName: 'מפגש מציעים', width: 130, type: 'date' },
  { field: 'clarification_date', headerName: 'שאלות הבהרה', width: 130, type: 'date' },
  { field: 'submission_date', headerName: 'מועד הגשה', width: 130, type: 'date' },
  { field: 'win_status', headerName: 'תוצאה', width: 120 },
  { field: 'priority', headerName: 'תעדוף', width: 90 },
  { field: 'notes', headerName: 'הערות', width: 200 },
];

// ===== TENDER SUB-PAGES =====
export const TENDER_SUB_PAGES = [
  { key: 'conditions', label: 'תנאי סף', icon: 'Checklist' },
  { key: 'quality_score', label: 'ניקוד איכות', icon: 'Grade' },
  { key: 'clarifications', label: 'שאלות הבהרה', icon: 'QuestionAnswer' },
  { key: 'tasks', label: 'משימות', icon: 'Assignment' },
];

// ===== API CONFIG =====
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_ITEMS_PER_PAGE = 25;

// ===== ALERT THRESHOLDS =====
export const ALERT_DAYS_CRITICAL = 3;
export const ALERT_DAYS_WARNING = 7;
